__turbopack_context__.v({
  "anchor": "QuickAdd-module-scss-module__ElnhWG__anchor",
  "overlay": "QuickAdd-module-scss-module__ElnhWG__overlay",
  "overlayVisible": "QuickAdd-module-scss-module__ElnhWG__overlayVisible",
  "root": "QuickAdd-module-scss-module__ElnhWG__root",
  "rootClipped": "QuickAdd-module-scss-module__ElnhWG__rootClipped",
});
